<script setup lang="ts">
import type { PropertyPriceProps } from '.';
import type IntervalInput from '~/components/IntervalInput/Input.vue';

import { propertyPriceInputVariants } from '.';

const props = withDefaults(defineProps<PropertyPriceProps>(), {
	variant: 'primary'
});

const min = defineModel<number | null>('min');
const max = defineModel<number | null>('max');

const intervalInputRef = ref<InstanceType<typeof IntervalInput> | null>(null);

defineExpose({
	focusFirstInputWhenReady: () =>
		intervalInputRef.value?.focusFirstInputWhenReady()
});
</script>

<template>
	<IntervalInput
		ref="intervalInputRef"
		v-model:min="min"
		v-model:max="max"
		title="Valor de venda"
		unit="currency"
		min-label="Preço mínimo"
		max-label="Preço máximo"
		update-on="blur"
		:variant="props.variant"
		:input-classes="propertyPriceInputVariants({ variant: props.variant })"
	/>
</template>
